export default "__VITE_ASSET__DQ4e8OC5__"